'use strict';
var KeyMirror = require('keymirror');

const Labels = {
    setupSuperFirstTransfer: 'Set up SuperFirst Transfer'
};

module.exports = {
    ActionTypes: KeyMirror({        
        UPDATE_SUPER_FIRST_DATA: null,
        UPDATE_IS_ADVICE_FEE_ONEOFF_EXIST: null
    }),
    Labels: Labels
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./constants/SuperFirstTransferConstant.js